module.exports = __webpack_public_path__ + "static/media/circlePhoto-19.100794c8.png";